import { Contact } from "../global";

export function findPrimaryContact(contacts: Array<Contact> | undefined): Contact | undefined {
    return contacts?.find((contact: Contact) => contact.contactTypeCode === "P")
}